<template>
  <div>
    <b-row  >
      <b-col xxs="12" class=" mt-5 text-center">
        <i class="lni lni-map text-danger mb-5" style="font-size:72px"></i>
        <h1>Please <strong>enable location access as well push notifcation access</strong> in your browser.</h1>
        <p class="text-danger maxWidth500 mx-auto">In order for this application to function correctly, please allow location access and notification access in your browser settings. Then <router-link to="/home" class="text-primary font-weight-bold"> click here to continue.</router-link> </p> <br>

        <router-link to="/home" class="btn btn-primary btn-lg">Continue</router-link>

      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appName: process.env.VUE_APP_APP_NAME,
    };
  },
};
</script>
